// extracted by mini-css-extract-plugin
export default {"wrapper":"I8S7Du7j_2dkGmZ0eJOz","userResourcesSelectionPanel":"_kVePi14xqRF2lDQke1f"};